import { useState } from 'react';
import { IconButton, Popover } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { onChangeViewSelected, scrollToView } from '../handler/ViewHandler';
import { getViewDisplayName } from '@/common/utils/ViewUtils';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function SeemoreViewKnowledgeList(props) {
    // Re-render when the translation dictionary loads/extends so view names update.
    useTranslationSubscription();

    const currentCorporationDetail = useRecoilValue(corporationAtom);
    const [clickTimeout, setClickTimeout] = useState(null);

    // item menu tabs
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // end item menu tabs

    const {
        listViewShow,
        viewSelected
    } = props;

    const onClickActiveTabChange = (e, ticketId, item) => {
        onChangeViewSelected(
            item,
            { ...props, clickTimeout, setClickTimeout },
            currentCorporationDetail
        )
        setAnchorEl(null);
        scrollToView(item?.id);
    };

    return (
        <div className="gNav-tabs">
            <IconButton
                className="itemNav"
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img src="/assets/image/icon-navTabs.svg" alt="" />
            </IconButton>
            <Popover
                className="navTabs-drop navTabs-drop--changePd"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <ul className="list-view-seemore">
                    {listViewShow.map(item => {
                        let viewName = getViewDisplayName(item);
                        return (
                            <li
                                key={item.id}
                                onClick={e => onClickActiveTabChange(e, item.id, item)}
                                className={`${viewSelected?.id === item.id && 'item-active-li'}`}
                            >
                                <OverFlowTooltipWithTabsMui value={viewName} />
                            </li>
                        );
                    })}
                </ul>
            </Popover>
        </div>
    );
}
